import { FieldOptions } from '../../interfaces';
import { selectField } from '../../models';

export const personTitles = ['Mr', 'Mrs', 'Miss', 'Ms', 'Mx', 'Dr', 'Reverend', 'Other'];

export const personTitleField = (state?: FieldOptions) => selectField('title', 'Title', personTitles, state);
